module.exports = __webpack_public_path__ + "static/media/ONRD-SPY-MY24-Ryker-Sport-000F5RB00-Studio-34FR-EU.846ce232.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Selection/assets/ONRD-SPY-MY24-Ryker-Sport-000F5RB00-Studio-34FR-EU.png
// module id = 685
// module chunks = 0